import { commonParams } from '@/common/utils'
import zhCN from '@/i18n/zh-CN/transition'
import enUS from '@/i18n/en-US/transition'
import esMX from '@/i18n/es-MX/transition'
import esCO from '@/i18n/es-CO/transition'
import es419 from '@/i18n/es-419/transition'
import ptBR from '@/i18n/pt-BR/transition'

export const langMap: { [key: string]: typeof enUS | typeof zhCN } = {
  'zh-CN': zhCN,
  'en-US': enUS,
  'es-MX': esMX,
  'es-CO': esCO,
  'es-419': es419,
  'pt-BR': ptBR,
}

function formatTextMessage(text: string, values: any) {
  const strList = text?.split(
    new RegExp(
      `(${Object.keys(values)
        ?.map((k) => '{{\\s*'.concat(k, '\\s*}}'))
        ?.join('|')})`,
      'g',
    ),
  );
  const nodes = strList?.map((str) => {
    const value = values[str.slice(2, -2).replace(/(^\s+|\s+$)/g, '')];
    if (value) {
      return value;
    }
    return str;
  });
  // if (hasElements(values)) {
  //   return React.createElement('span', null, ...nodes);
  // }
  return nodes?.join('');
}

export const I18nTranslate = (key: string, defaultValue?: string, values?: any) => {
  const l: any = langMap[commonParams()?.lang] || langMap['en-US'];
  const baseL: any = langMap['zh-CN'];
  let text = l[key] || defaultValue || baseL[key];
  // 兼容及联文案
  const keyObj = key?.split('.')
  if (keyObj.length > 1 ) {
    let t = l
    keyObj?.forEach((k: any) => t = t?.[k] )
    text = t
  }
  if (values) {
    return formatTextMessage(text, values);
  }
  return text;
}